import 'babel-polyfill';
//import fetch from 'isomorphic-fetch';

//import thunkMiddleware from 'redux-thunk';
import React, { PropTypes } from 'react';


import { ADD_FILLER, 
         RM_FILLER, 
         SELECT_FILLER, 
         ATTACH_FILLER,
         ATTACH_FILLERS,
         DETACH_FILLER, 
         SET_BANK_HOLIDAY_DATES,
         SET_NON_WORKING_DATES,
         CHANGE_FILLER,
         SET_PERIOD
       } from "./action_types";

import { createAction } from 'redux-actions';
import { createStore, combineReducers } from 'redux';
import { Provider, connect } from 'react-redux';
import { render } from 'react-dom';


import { CountTable } from "./react/presentationals/counts_table.js";
import { Calendar } from "./react/presentationals/calendar.js";

import { utcMonday, timeYear } from "d3";

import Immutable from "immutable";
import joinPlanChannel from "./socket";

import { utcDays, utcMonths } from "d3";




let actions = {
  selectFiller: createAction(SELECT_FILLER),
  addFiller: createAction(ADD_FILLER),
  rmFiller: createAction(RM_FILLER),
  attachFiller: createAction(ATTACH_FILLER),
  attachFillers: createAction(ATTACH_FILLERS),
  detachFiller: createAction(DETACH_FILLER),
  setBankHolidayDates: createAction(SET_BANK_HOLIDAY_DATES),
  setNonWorkingDates: createAction(SET_NON_WORKING_DATES),
  changeFiller: createAction(CHANGE_FILLER),
  setPeriod: createAction(SET_PERIOD)
};



const FillersSelection = ({ fillers, onClick } ) => (
  <div className="btn-group" >
    {fillers.entrySeq().map( ([key, fillerDef]) =>
      <label className={"btn filler" + key + "-btn"} key={key}>
        <input type="radio" 
               name="fillers"
               id={"fillerSelector" + key}
               autoComplete="off"
               onClick={() => onClick(key)} />
        {fillerDef.name}
      </label>
    )}
  </div>
);


let state = Immutable.Map({
  selectedFiller: null,
  fillersCounts: Immutable.Map(),
  datesWithFillers: Immutable.Map(),
  fillers: Immutable.Map(),
  specialDays: Immutable.Map(),
  periodInfo: Immutable.Map()
});


let clanner_planId = null;
let emb_fillers_id = null;
let emb_filler_dates_id = null;


// executed as part of the ATTACH_FILLER action
let updateFillerStats = ({ state, fillerId, datesWithFillers }) => {

  let numberOfAllocated = 0;
  
  datesWithFillers.forEach( (fillersOnDate) => {
    numberOfAllocated += 
      fillersOnDate.count( (fillerIdOnDate) => fillerIdOnDate === fillerId)
  });


  let fillersCounts = state.get("fillersCounts");
  let fillerStats = fillersCounts.get(fillerId);

  let fillers = state.get("fillers");
  let fillerDef = fillers.get(fillerId);
  let fillerTarget = fillerDef.target;


  let updatedFillerStats = fillerStats.set("allocated", numberOfAllocated);
  updatedFillerStats = updatedFillerStats.set("toAllocate", fillerTarget - numberOfAllocated);
  
  let updatedFillersCounts = fillersCounts.set(fillerId, updatedFillerStats);
  let newState = state.set("fillersCounts", updatedFillersCounts);

  return newState;
}


let updateAllFillersStats = ({ state, datesWithFillers }) => {

  let newState = state;

  datesWithFillers.forEach( (fillerIds)  => {
    fillerIds.forEach( (fillerId) => {
      newState = updateFillerStats({ state: newState, fillerId, datesWithFillers });
    });
  });

  return newState;
}


let attachFiller = ({ state, fillerId, date, datesWithFillers }) => {
    
  // if no filler given, stop right here
  if (fillerId === null) { return state }

  let fillersOnDate = datesWithFillers.get(date);

  if (fillersOnDate === undefined) {
    
    datesWithFillers = datesWithFillers.set(date, Immutable.List([fillerId]));
  } else {
    fillersOnDate = fillersOnDate.push(fillerId);
    datesWithFillers = datesWithFillers.set(date, fillersOnDate);
  }
  let newState = state.set("datesWithFillers", datesWithFillers);

  
  // update filler stats
  newState = updateFillerStats({ state: newState, fillerId, datesWithFillers });


  return newState;
};


let attachFillers = ({ state, datesWithFillersToSet, datesWithFillers }) => {
  let newState;

  if (datesWithFillersToSet && Object.keys(datesWithFillersToSet).length > 0) {

    for (let [date, fillerIds] of Object.entries(datesWithFillersToSet)) {
      
      datesWithFillers = datesWithFillers.set(date, Immutable.List(fillerIds));
      
    }
  }

  newState = state.set("datesWithFillers", datesWithFillers);
  newState = updateAllFillersStats({ state: newState, datesWithFillers });
  return newState;
};


let detachFiller = ({ state, fillerId, date, datesWithFillers, index }) => {

  // if no filler given, stop right here
  if (fillerId === null) { return state }

  let fillersOnDate = datesWithFillers.get(date);

  if (fillersOnDate) {
    
    fillersOnDate = fillersOnDate.delete(index);
    datesWithFillers = datesWithFillers.set(date, fillersOnDate);
    let newState = state.set("datesWithFillers", datesWithFillers);

    // update filler stats
    newState = updateFillerStats({ state: newState, fillerId, datesWithFillers });

    return newState;
  }
  return state;

};




let reducer = (state, action) => {
  let date;
  let fillerId, datesWithFillers; // to prevent duplicate declaration errors
  let fillersCounts, newState, specialDays, fillers, fillerDef;

  switch (action.type) {

    case SET_PERIOD:
      let periodInfo = initPeriodInfo(action.payload);
      return state.set("periodInfo", periodInfo);

    case CHANGE_FILLER:
      fillers = state.get("fillers");
      fillerDef = action.payload.fillerDef;

      let updatedFillers = fillers.update(fillerDef.key, (existingFiller) => {
        let obj = {
          key: fillerDef.key,
          name: existingFiller.name,
          target: existingFiller.target
        };
        if (fillerDef.name) {
          obj.name = fillerDef.name;
        }
        if (fillerDef.target) {
          obj.target = parseInt(fillerDef.target);
        }
        
        return obj;
      });

      newState = state.set("fillers", updatedFillers);

      datesWithFillers = state.get("datesWithFillers");
      newState = updateFillerStats({ state: newState, fillerId: fillerDef.key, datesWithFillers });

      return newState;
      

    case SET_NON_WORKING_DATES:
      specialDays = state.get("specialDays");
      specialDays = specialDays.set("nonWorkingDates", Immutable.List(action.payload.dates));
      newState = state.set("specialDays", specialDays);
      return newState;


    case SET_BANK_HOLIDAY_DATES:
      specialDays = state.get("specialDays");
      specialDays = specialDays.set("bankHolidayDates", Immutable.List(action.payload.dates));
      newState = state.set("specialDays", specialDays);
      return newState;


    case ADD_FILLER:
      fillers = state.get("fillers");
      fillerDef = action.payload.fillerDef;

      // add a filler key if it does not exist (i.e. it hasn't been stored yet)
      if (!fillerDef.key) {
        let key = "0";
        if (fillers.size > 0) {
          let maxKey = fillers.keySeq().max();
          key = (parseInt(maxKey) + 1).toString();
        }
        fillerDef.key = key;
      }

      newState = state.set("fillers", fillers.set(fillerDef.key, fillerDef));

      // init filler count
      let initialFillerStats = Immutable.Map({
        "key": fillerDef.key,
        "allocated": 0,
        "toAllocate": fillerDef.target
      })

      fillersCounts = state.get("fillersCounts");
      fillersCounts = fillersCounts.set(fillerDef.key, initialFillerStats);
      newState = newState.set("fillersCounts", fillersCounts);

      return newState;


    case SELECT_FILLER:
      return state.set("selectedFiller", action.payload);
    

    case ATTACH_FILLER:
      fillerId = action.payload.fillerId;
      date = action.payload.date;

      fillerId = fillerId !== undefined ? fillerId : state.get("selectedFiller");

      datesWithFillers = state.get("datesWithFillers");

      return attachFiller({ state, fillerId, date, datesWithFillers });


    case ATTACH_FILLERS:
      let datesWithFillersToSet = action.payload.fillerDates;
      datesWithFillers = state.get("datesWithFillers");

      return attachFillers({ state, datesWithFillersToSet, datesWithFillers });


    case DETACH_FILLER:
      fillerId = action.payload.fillerId;
      date = action.payload.date;
      let index = action.payload.index;

      fillerId = fillerId !== undefined ? fillerId : state.get("selectedFiller");

      datesWithFillers = state.get("datesWithFillers");

      return detachFiller({ state, fillerId, date, index, datesWithFillers });

      
    default:
      return state;
  }
};



let appStore = createStore(reducer, state);


const counts_mapStateToProps = (state) => {
  return {
    fillersCounts: state.get("fillersCounts"),
    fillers: state.get("fillers")
  }
}

const counts_mapDispatchToProps = (dispatch) => {
  return {
    setFiller: (fillerDef) => {
      dispatch(actions.changeFiller(fillerDef));
    }
  }
}


const FillersCounts = connect(counts_mapStateToProps, counts_mapDispatchToProps)(CountTable);


const fillersMapStateToProps = (state) => {
  return {
    fillers: state.get("fillers")
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onClick: (fillerId) => {
      dispatch(actions.selectFiller(fillerId));
    }
  }
}

const Fillers = connect(fillersMapStateToProps, mapDispatchToProps)(FillersSelection);



let initPeriodInfo = ({ yearType, year }) => {
  let info = {};
  // implemenation for financial year only for now
  let init = () => {
    let yearFrom, yearTo, years;

    switch (yearType) {  
      case "UK_F": // UK Financial Year
        years = year.split("/");
        yearFrom = parseInt(years[0]);
        yearTo = parseInt(years[1]);

        info.start = new Date(yearFrom, 3, 1);
        info.end = new Date(yearTo, 3, 1);

        info.isFirstYear = (date) => date.getFullYear() === info.startCalendarYear;

        break;
    
      case "C": // Calendar year
        year = parseInt(year);
        yearFrom = year;
        yearTo = year; 

        info.start = new Date(yearFrom, 0, 1);
        info.end = new Date(yearTo + 1, 0, 1);

        info.isFirstYear = (_date) => true;

        break;
    }
      
    info.startWeekNumber = utcMonday.count(timeYear(info.start), info.start);
    info.endWeekNumber = utcMonday.count(timeYear(info.end), info.end);
    info.startCalendarYear = info.start.getFullYear();
    info.endCalendarYear = info.end.getFullYear();
    info.days = utcDays(info.start, info.end); 
    info.months = utcMonths(info.start, info.end);
    info.yearLabel = year;
    
  }
  init();
  return info;
};


const calendarMapStateToProps = (state) => {
  return {  
    datesWithFillers: state.get("datesWithFillers"),
    fillers: state.get("fillers"),
    specialDays: state.get("specialDays"),
    periodInfo: state.get("periodInfo")

  }
}

const calendarMapDispatchToProps = (dispatch) => {
  return {
    attachFiller: (date) => dispatch(actions.attachFiller({ date: date })),
    detachFiller: (opts) => dispatch(actions.detachFiller(opts)) // opts like {date, fillerId}
  }
}


const CalendarContainer = connect(calendarMapStateToProps, calendarMapDispatchToProps)(Calendar);



let newActivity = '';

let addNewFiller = () => {
  if (newActivity.value !== "") {
    
    let fillerDef = { name: newActivity.value, target: 0 };
    appStore.dispatch(actions.addFiller({ fillerDef }));
    newActivity.value = "";
  }
}



const App = () => (
  <div>
    <div className="col-sm-2 add-filler">
      <div className="input-group">
        <input type="text" 
               className="form-control" 
               placeholder="New activity..."
               ref={(input) => newActivity = input } />
        <span className="input-group-btn">
          <button className="btn btn-primary" 
                  type="button" 
                  onClick={addNewFiller}>Add!</button>
        </span>
      </div>
    </div>
    <div className="clearfix"></div>
    <FillersCounts />
    <Fillers />
    <div className="clearfix"></div>
    <CalendarContainer />
  </div>
);


// let unsubscribe = appStore.subscribe(() =>
//   console.log(appStore.getState())
// )


export function exec() {


  render(
    <Provider store={appStore}>
      <App />
    </Provider>,
    document.getElementById("app")
  );

    
}


export function savePlan() {
  let state = appStore.getState();

  let fillerDates = state.get("datesWithFillers");
  let fillers = state.get("fillers");

  let planData = {
    plan_id: clanner_planId,
    emb_filler_dates: {
      id: emb_filler_dates_id,
      filler_dates: fillerDates
    },
    emb_fillers: {
      id: emb_fillers_id,
      fillers: fillers
    }
  }


  serverChannel.push("save_plan", { body: planData })
    .receive("ok", (payload) => {
      alert("Saved! :-)");
    })
    .receive("error", (payload) => {
      alert("Error, not saved! :-(");
    })

}


let serverChannel; 


export function loadPlan(planId) {

  serverChannel = joinPlanChannel(planId);

  serverChannel.push("get_plan", { plan_id: planId })
    .receive("ok", (payload) => {

      appStore.dispatch(actions.setPeriod( { year: payload.year, yearType: payload.year_type }));

      if (payload.fillers) {
        emb_fillers_id = payload.fillers.id;

        for (let id in payload.fillers.fillers) {
          let fillerDef = payload.fillers.fillers[id];
          fillerDef.key = id;
          appStore.dispatch(actions.addFiller({ fillerDef }));
        }
      }


      if (payload.filler_dates) {
        emb_filler_dates_id = payload.filler_dates.id;

        appStore.dispatch(actions.attachFillers({ fillerDates: payload.filler_dates["filler_dates"] }));
      }

      
      let periodInfo = appStore.getState().get("periodInfo");

      serverChannel.push("get_bank_hols", { "date_from": periodInfo.start, "date_to": periodInfo.end })
        .receive("ok", (payload) => {
          let bankHolidayDates = payload.dates;
          if (bankHolidayDates && bankHolidayDates.length > 0) {
            appStore.dispatch(actions.setBankHolidayDates({ dates: bankHolidayDates }));
          }
        })


      let nonWorkingDaysDefinition = [{dayNumber: 0, repeat: "all"}, {dayNumber: 1, repeat: "all"}]

      let buildNonWorkingDates = (nonWorkingDaysDefinition) => {
        if (nonWorkingDaysDefinition && nonWorkingDaysDefinition.length > 0) {
          // to-do: refactor - same code is in calendar
          const getDayNumber = (date) => {
            return (date.getDay() + 6) % 7; // day number - starting from Monday
          };

          let nonWorkingDates = [];
          let allDays = periodInfo.days;
          allDays.forEach( (date) => {
            nonWorkingDaysDefinition.forEach( (def) => {
              if(def.dayNumber !== null && def.dayNumber === getDayNumber(date)) {
                nonWorkingDates.push(date);
              }
            });
          });
          appStore.dispatch(actions.setNonWorkingDates({ dates: nonWorkingDates }));
        }
      }

      buildNonWorkingDates(nonWorkingDaysDefinition);


  }); // END OF get_plan FROM SERVER





  // let serverPlanData = {
  //   planId: 2,
  //   periodType: "finYear",
  //   fillers: {
  //       "0": {
  //          name: "Keighley Clinic",
  //          target: 38
  //       },
  //       "1": {
  //          name: "Airedale Clinic",
  //          target: 42
  //      }, {
  //       key: "3",
  //       name: "CDC Feeding Clinic",
  //       target: 5
  //     }
  //   ],
  //   bankHolidayDates: ["2016-05-02", "2016-05-30", "2016-08-29", "2016-12-26", "2016-12-27", "2017-01-02", "2017-04-14", "2017-04-17", "2017-05-01", "2017-05-29", "2017-08-28", "2017-12-25", "2017-12-26", "2018-01-01", "2018-03-30", "2018-04-02", "2018-05-07", "2018-05-28"],
  //   fillerDates: {
  //      "0": ["2016-04-13", "2016-05-11", "2016-06-29"],
  //      "1": ["2016-04-13", "2016-05-20", "2016-06-10", "2016-09-16"],
  //      "6": ["2016-04-13", "2016-08-03", "2016-08-04", "2016-08-05"]
  //   }
  // };  
  
  // serverPlanData.fillers.forEach( (fillerDef) => {
  //       appStore.dispatch(actions.addFiller({ fillerDef }));
  //     });
  
  clanner_planId = planId;


}


/** WEBPACK FOOTER **
 ** ./web/static/js/clanner.js
 **/